<template>
  <el-dialog
    :visible.sync="isShow"
    width="480px"
    custom-class="ShortDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <span>{{ title }}</span>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content">
        <!-- 公共说明 -->
        <div class="warn-box">
          <svg-btn icon-class="icon-tips-circle-fill" />
          <span>严禁分享反动、暴力、色情、违法及侵权内容的链接。</span>
        </div>
        <!-- 单个新建 -->
        <div class="shortLink" v-if="isType == 1">
          <!-- 短链信息 创建成功 -->
          <div class="file-info" v-if="isStatus == 2">
            <img class="icon" :src="web_icon" />
            <div class="info">
              <div class="nameBox">
                <span class="name">{{ url_title }}</span>
                <svg-btn
                  @click="editLink"
                  class="edit"
                  icon-class="icon-short-edit"
                />
              </div>
              <span class="link">{{ jump_url }}</span>
            </div>
          </div>

          <!-- 短链地址 编辑 -->
          <div class="formBox" v-if="isStatus == 3">
            <div class="fontBox">
              <span class="font">短链地址</span>
            </div>
            <el-input
              class="addressInput"
              v-model="share_url"
              readonly
              placeholder=""
              clearable
            ></el-input>
          </div>

          <!-- 目标网址 新建 编辑 -->
          <div class="formBox" v-if="isStatus == 1 || isStatus == 3">
            <div class="fontBox" style="justify-content: space-between">
              <div class="left">
                <span class="red">*</span>
                <span class="font">目标网址</span>
              </div>
              <el-tooltip
                effect="dark"
                v-if="white_list != ''"
                placement="bottom-start"
                popper-class="short-popper"
              >
                <div slot="content">
                  支持创建短链的域名：<br />
                  <span>{{ white_list }}</span>
                  <div>迅雷链thunder://、磁力链接magnet:</div>
                </div>
                <div class="left">
                  <svg-btn class="icon2" icon-class="icon-share-2" />
                  <span class="right">查看支持域名</span>
                </div>
              </el-tooltip>
            </div>
            <el-input
              v-model="jump_url"
              clearable
              placeholder="请输入需要缩短的链接"
            ></el-input>
          </div>

          <!-- 分享模式 -->
          <div class="formBox">
            <div class="fontBox" style="justify-content: space-between">
              <div class="left">
                <span class="red">*</span>
                <span class="font">分享模式</span>
                <el-tooltip
                  effect="dark"
                  content="开通CloudMaster立即体验所有分享模式"
                  placement="top"
                >
                  <svg-btn class="icon" icon-class="icon-share-1" />
                </el-tooltip>
              </div>
              <span class="right" @click="toCm">查看分享简介</span>
            </div>
            <!-- :class="{
                disSelet: isStatus == 2,
              }"
              :disabled="isStatus == 2" -->
            <el-select
              v-model="rebate_model"
              popper-class="share_select"
              placeholder="请选择短链分享模式"
              @change="incomeModeChange"
            >
              <el-option
                v-for="item in rebateList"
                :key="item.id"
                :label="item.name"
                :style="item.disabled == '1' ? 'cursor: pointer ' : ''"
                :value="item.id"
                :disabled="item.disabled == 1"
              >
                <div class="share_select_box" @click.prevent="toDaren(item)">
                  <div
                    class="income-name"
                    :class="item.disabled == '0' ? '' : 'income-name1'"
                  >
                    {{ item.name }}
                  </div>
                  <div class="income-right">
                    <div
                      class="income-intr"
                      v-if="item.info"
                      :class="
                        item.disabled == '1'
                          ? 'income-daren0'
                          : item.disabled == '0'
                          ? 'income-daren'
                          : ''
                      "
                    >
                      <img
                        v-if="item.disabled == '1'"
                        style="width: 14px; height: 14px; margin-right: 2px"
                        :src="$utils.getPng('web4/icon_mom')"
                      />
                      {{ item.info }}
                    </div>
                    <div class="income-checkbox">
                      <img
                        class="icon-scheck"
                        v-show="item.id == rebate_model"
                        :src="$utils.getPng('web4/icon-share-check')"
                      />
                    </div>
                  </div>
                </div>
              </el-option>
            </el-select>
          </div>
          <!-- 标题 新建 编辑 -->
          <div
            class="formBox"
            style="margin-bottom: 0"
            v-if="isStatus == 1 || isStatus == 3"
          >
            <div class="fontBox">
              <span class="font">标题</span>
            </div>
            <el-input
              class="title"
              v-model="url_title"
              resize="none"
              autosize
              placeholder="请输入短链标题（最多50字）"
              maxlength="50"
              type="textarea"
            >
            </el-input>
          </div>

          <!-- 分享短链 创建成功 -->
          <div class="formBox" style="margin-bottom: 0" v-if="isStatus == 2">
            <div class="fontBox">
              <span class="font">分享短链</span>
            </div>
            <div class="urlBox">
              <el-input
                readonly
                v-model="share_url"
                placeholder=""
                clearable
              ></el-input>
              <fm-button
                class="copy-btn"
                round
                size="medium"
                @click="copyUrl(1)"
                >复制短链</fm-button
              >
            </div>
          </div>
        </div>
        <!-- 批量新建 -->
        <div class="shortLink" v-if="isType == 2">
          <!-- 目标网址 新建 编辑 -->
          <div class="formBox" v-if="isStatus == 1">
            <div class="fontBox" style="justify-content: space-between">
              <div class="left">
                <span class="red">*</span>
                <span class="font">目标网址</span>
              </div>
              <el-tooltip
                effect="dark"
                v-if="white_list != ''"
                placement="bottom-start"
                popper-class="short-popper"
              >
                <div slot="content">
                  支持创建短链的域名：<br />
                  <span>{{ white_list }}</span>
                  <div>迅雷链thunder://、磁力链接magnet:</div>
                </div>
                <div class="left">
                  <svg-btn class="icon2" icon-class="icon-share-2" />
                  <span class="right">查看支持域名</span>
                </div>
              </el-tooltip>
            </div>
            <el-input
              class="allTitle"
              v-model="jump_url"
              resize="none"
              autosize
              placeholder="请输入需要缩短的链接（最多一次添加20个，每行一个）"
              type="textarea"
            >
            </el-input>
          </div>

          <!-- 分享模式 -->
          <div class="formBox" v-if="isStatus == 1">
            <div class="fontBox" style="justify-content: space-between">
              <div class="left">
                <span class="red">*</span>
                <span class="font">分享模式</span>
                <el-tooltip
                  effect="dark"
                  content="开通CloudMaster立即体验所有分享模式"
                  placement="top"
                >
                  <svg-btn class="icon" icon-class="icon-share-1" />
                </el-tooltip>
              </div>
              <span class="right" @click="toCm">查看分享简介</span>
            </div>
            <el-select
              v-model="rebate_model"
              popper-class="share_select"
              placeholder="请选择短链分享模式"
              :class="{
                disSelet: isStatus == 2,
              }"
              :disabled="isStatus == 2"
              @change="incomeModeChange"
            >
              <el-option
                v-for="item in rebateList"
                :key="item.id"
                :label="item.name"
                :style="item.disabled == '1' ? 'cursor: pointer ' : ''"
                :value="item.id"
                :disabled="item.disabled == 1"
              >
                <div class="share_select_box" @click.prevent="toDaren(item)">
                  <div
                    class="income-name"
                    :class="item.disabled == '0' ? '' : 'income-name1'"
                  >
                    {{ item.name }}
                  </div>
                  <div class="income-right">
                    <div
                      class="income-intr"
                      v-if="item.info"
                      :class="
                        item.disabled == '1'
                          ? 'income-daren0'
                          : item.disabled == '0'
                          ? 'income-daren'
                          : ''
                      "
                    >
                      <img
                        v-if="item.disabled == '1'"
                        style="width: 14px; height: 14px; margin-right: 2px"
                        :src="$utils.getPng('web4/icon_mom')"
                      />
                      {{ item.info }}
                    </div>
                    <div class="income-checkbox">
                      <img
                        class="icon-scheck"
                        v-show="item.id == rebate_model"
                        :src="$utils.getPng('web4/icon-share-check')"
                      />
                    </div>
                  </div>
                </div>
              </el-option>
            </el-select>
          </div>

          <!-- 标题 新建 编辑 -->
          <div class="formBox" style="margin-bottom: 0" v-if="isStatus == 1">
            <div class="fontBox">
              <span class="font">标题</span>
            </div>
            <el-input
              class="titleAll"
              v-model="url_title"
              resize="none"
              autosize
              placeholder="请输入短链标题（每行一个）"
              type="textarea"
            >
            </el-input>
          </div>

          <!-- 分享短链 创建成功 -->
          <div
            class="formBox"
            style="padding-bottom: 4px; margin-bottom: 0"
            v-if="isStatus == 4"
          >
            <div class="fontBox">
              <span class="font">标题</span>
              <span class="font" style="margin-left: 198px">短链</span>
            </div>
            <div class="batchBox">
              <div class="batch" v-for="(item, index) in batchUrl" :key="index">
                <span class="bfont1">{{ item.url_title }}</span>
                <span class="bfont1" style="margin-right: 0">{{
                  item.share_url
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-footer" v-if="isStatus != 2">
        <fm-button
          v-if="isStatus == 1"
          :disabled="btnOne"
          @click="addLink()"
          type="primary"
          size="mdeium"
          round
          :loading="loading"
          style="font-size: 14px"
        >
          创建短链
        </fm-button>
        <!-- 编辑 按钮 -->
        <fm-button
          v-if="isStatus == 3"
          :disabled="btnOne"
          @click="confirm"
          round
          type="primary"
          size="mdeium"
          :loading="loading"
          style="font-size: 14px"
          >确 认</fm-button
        >
        <fm-button
          v-if="isStatus == 3"
          @click="cancel"
          round
          type="info"
          plain
          size="mdeium"
          style="font-size: 14px"
          >取 消</fm-button
        >
        <!-- 编辑 按钮 -->

        <!-- 批量创作成功 按钮 -->
        <fm-button
          v-if="isStatus == 4"
          @click="copyUrl(3)"
          round
          type="primary"
          size="mdeium"
          style="font-size: 14px"
          >复制标题和短链</fm-button
        >
        <fm-button
          v-if="isStatus == 4"
          @click="copyUrl(2)"
          round
          type="info"
          plain
          size="mdeium"
          style="font-size: 14px"
          >复制短链</fm-button
        >
        <!-- 批量创作成功 按钮 -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  addShort,
  editShort,
  shortDetail,
  batchCreateAPI,
  shortModel,
} from '@/utils/apiList/short'
export default {
  props: {
    //是否显示
    isShow: {
      type: Boolean,
      default: false,
    },
    //1是单个新建 2是批量新建
    isType: {
      type: [Number, String],
      default: 1,
    },
    // //1是新建 2是新建成功 3是编辑 4是批量创建成功
    // isStatus: {
    //   type: [Number, String],
    //   default: 1,
    // },
    // 2是查看 3是编辑
    status: {
      type: [Number, String],
      default: 0,
    },
    // 分享和编辑
    zcfshort: {
      type: String,
      default: '',
    },
    //分享模式list
    rebateList: {
      type: Array,
      default: [],
    },
    //支持域名
    white_list: {
      type: Array,
      default: '',
    },
  },
  data() {
    return {
      isStatus: 1, //1是新建 2是新建成功 3是编辑 4是批量创建成功
      jump_url: '', //目标网址
      web_icon: this.$utils.getPng('icon-short-urls'), //图标
      rebate_model: '', //返利模式  1-免登录无条件跳转 2-登录后无条件跳转 3-去小程序看广告后跳转 4-去APP看广告后跳转
      url_title: '', //标题
      fshort: '', //生产的fshort
      share_url: '', //生成的链接
      batchUrl: [], //生成的url数据
      ed_jump_url: '', //编辑暂存目标网址
      ed_rebate_model: '', //编辑暂存返利模式
      ed_url_title: '', //编辑暂存标题
      loading: false,
    }
  },

  computed: {
    btnOne() {
      let state = true
      if (this.jump_url && this.rebate_model) {
        state = false
      }
      return state
    },
    title() {
      //isType 1是单个新建 2是批量新建
      //isStatus 1是新建 2是新建成功 3是编辑 4是批量创建成功
      if (this.isType == 2) {
        if (this.isStatus == 4) {
          return '分享多个短链'
        }
        return '批量新建短链'
      }
      if (this.isStatus == 2) {
        return '分享短链'
      } else if (this.isStatus == 3) {
        return '编辑短链'
      } else {
        return '新建短链'
      }
    },
  },
  watch: {
    isShow: function (val) {
      if (val) {
        if (this.status == 2 || this.status == 3) {
          this.isStatus = this.status
          shortDetail({
            fshort: this.zcfshort,
          })
            .then(res => {
              if (res.status == 1) {
                this.fshort = res.data.detail.fshort
                this.jump_url = res.data.detail.jump_url
                this.web_icon = res.data.detail.web_icon
                this.rebate_model = res.data.detail.rebate_model
                this.share_url = res.data.detail.share_url
                this.url_title = res.data.detail.url_title
                if (this.status == 3) {
                  this.ed_jump_url = this.jump_url
                  this.ed_rebate_model = this.rebate_model
                  this.ed_url_title = this.url_title
                }
              }
            })
            .catch(err => {})
        } else {
          this.getShortModel()
        }
      }
    },
  },
  methods: {
    //获取模式
    getShortModel() {
      shortModel()
        .then(res => {
          if (res.status == 1) {
            this.$emit('upRebate', res.data.config)
            let arr = res.data.config.find(item => item.select == 1)
            this.rebate_model = arr?.id
          }
        })
        .catch(err => {})
    },
    //新建短链
    addLink: _.debounce(
      function () {
        if (this.btnOne || this.loading) {
          return
        }
        let data = {
          // jump_url: this.jump_url,
          content: this.jump_url,
          rebate_model: this.rebate_model,
          url_title: this.url_title,
          is_single: this.isType,
        }
        this.loading = true
        batchCreateAPI(data)
          .then(res => {
            if (res.status == 1) {
              this.fshort = res.data.fshort
              this.web_icon = res.data.web_icon
              if (this.isType == 1) {
                this.url_title = res.data.list[0]?.url_title
                this.jump_url = res.data.list[0]?.jump_url
                this.share_url = res.data.list[0]?.share_url
                this.isStatus = 2
              } else {
                this.batchUrl = res.data.list
                this.isStatus = 4
              }
              this.$toast(res.msg, 1)
              this.loading = false
              this.$emit('refresh')
            } else if (res.status == 2) {
              this.loading = false
              this.$toast(res.msg, 2)
            } else {
              this.loading = false
              this.$toast(res.msg, 3)
            }
          })
          .catch(err => {
            this.loading = false
          })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //点击编辑
    editLink() {
      this.ed_jump_url = this.jump_url
      this.ed_rebate_model = this.rebate_model
      this.ed_url_title = this.url_title
      this.isStatus = 3
    },
    //编辑短链确认事件
    confirm: _.debounce(
      function () {
        if (this.btnOne || this.loading) {
          return
        }
        if (
          this.jump_url == this.ed_jump_url &&
          this.rebate_model == this.ed_rebate_model &&
          this.url_title == this.ed_url_title
        ) {
          this.isStatus = 2
          return
        }
        let data = {
          jump_url: this.jump_url,
          rebate_model: this.rebate_model,
          url_title: this.url_title,
          fshort: this.fshort,
        }
        this.loading = true
        editShort(data).then(res => {
          if (res.status == 1) {
            this.url_title = res.data.url_title
            this.isStatus = 2
            this.$emit('refresh')
            this.loading = false
            this.$toast(res.msg, 1)
          } else if (res.status == 2) {
            this.loading = false
            this.$toast(res.msg, 2)
          } else {
            this.loading = false
            this.$toast(res.msg, 3)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //编辑短链取消事件
    cancel() {
      if (this.status == 3) {
        this.handleClose()
      } else {
        this.jump_url = this.ed_jump_url
        this.rebate_model = this.ed_rebate_model
        this.url_title = this.ed_url_title
        this.isStatus = 2
      }
    },
    //关闭弹窗，清除状态
    handleClose() {
      this.$emit('handleClose')
      setTimeout(() => {
        this.jump_url = ''
        this.rebate_model = ''
        this.url_title = ''
        this.fshort = ''
        this.share_url = ''
        this.batchUrl = []
        this.ed_jump_url = ''
        this.ed_rebate_model = ''
        this.ed_url_title = ''
        this.isStatus = 1
      }, 200)
    },
    //复制短链
    copyUrl(num) {
      let url
      if (num == 1) {
        url = this.share_url
      } else if (num == 2) {
        let arr = []
        this.batchUrl.forEach(item => {
          arr.push(item.share_url)
        })
        url = arr.join('\n')
      } else if (num == 3) {
        // 处理数组，生成拼接后的字符串
        url = this.batchUrl
          .map(item => {
            return `${item.url_title} ${item.share_url}`
          })
          .join('\n')
      }
      this.$copyText(url).then(
        e => {
          let msg = num == 3 ? '复制标题和短链成功' : '复制短链成功'
          this.$toast(msg, 1)
        },
        function (e) {}
      )
    },
    //点击模式下拉框事件
    incomeModeChange(id) {
      if (this.isStatus == 2) {
        let data = {
          jump_url: this.jump_url,
          rebate_model: this.rebate_model,
          url_title: this.url_title,
          fshort: this.fshort,
        }
        editShort(data).then(res => {
          if (res.status == 1) {
            this.$emit('refresh')
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      }
    },
    //点击跳转达人中心
    toDaren(item) {
      if (item.disabled == 1) {
        window.open(`${this.$glb.goLLZ}`, '_blank')
        return
      }
    },
    //点击跳转达人中心-帮助中心-短链
    toCm() {
      window.open(`${this.$glb.goLLZ}/help?tag=11`, '_blank')
    },
  },
}
</script>

<style lang="scss">
.ShortDialog {
  .el-dialog__body {
    padding: 0 !important;
  }
  .dialog-body {
    padding-bottom: 24px;
  }
  .d-header {
    margin: 20px 0 0 24px;
  }
  .d-content {
    .share_select {
      .is-disabled:hover {
        @include useTheme {
          background: getVar('bg-color-fill2');
        }
      }
    }
    .share_select_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      position: relative;
    }
    .warn-box {
      height: 32px;
      @include useTheme {
        background: getVar('text-color1-f9f9f9');
      }
      display: flex;
      align-items: center;
      margin-top: 16px;
      .svg-icon {
        width: 16px;
        height: 16px;
        margin-left: 24px;
        margin-right: 8px;
      }
      span {
        font-size: 12px;
        line-height: 20px;
        @include useTheme {
          color: getVar('text-color1-8a8b92');
        }
      }
    }
    .file-info {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .icon {
        width: 36px;
        height: 36px;
        margin-right: 16px;
        object-fit: cover;
      }
      .info {
        display: flex;
        flex-direction: column;
        .nameBox {
          display: flex;
          align-items: center;
          .name {
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            max-width: 368px;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            @include useTheme {
              color: getVar('text-color2-2c2c2c');
            }
          }
          .edit {
            width: 14px;
            height: 14px;
            margin-left: 4px;
            cursor: pointer;
            @include useTheme {
              color: getVar('text-color1-8a8b92');
            }
          }
        }
        .link {
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          max-width: 368px;
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          @include useTheme {
            color: getVar('text-color1-8a8b92');
          }
        }
      }
    }
    .shortLink {
      padding: 16px 24px 0 24px;
      .formBox {
        margin-bottom: 24px;
        .fontBox {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          .left {
            display: flex;
            align-items: center;
          }
          .right {
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            cursor: pointer;
            @include useTheme {
              color: getVar('text-color1-8a8b92');
            }
          }
          .font {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
            }
          }
          .red {
            @include useTheme {
              color: getVar('text-color1-F53F3F') !important;
            }
          }
          .icon {
            width: 16px;
            height: 16px;
            margin-left: 4px;
          }
          .icon2 {
            width: 16px;
            height: 16px;
            margin-right: 4px;
            margin-bottom: 1px;
          }
        }
        .disSelet {
          .el-input__inner {
            @include useTheme {
              color: getVar('text-color1-8a8b92');
            }
          }
        }
        .urlBox {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .el-input {
            width: 264px;
          }
          .el-input__inner {
            width: 264px;
            height: 40px;
            @include useTheme {
              background: getVar('text-color1-f9f9f9');
              border: 1px solid getVar('color-e5e5e5-3b3b3b');
              color: getVar('text-color1-8a8b92');
            }
            border-radius: 8px;
            font-size: 12px;
            padding-left: 12px;
            line-height: 40px;
          }
          .copy-btn {
            width: 152px;
            height: 40px;
          }
        }
        .el-select {
          width: 100%;
        }
        .title {
          .el-textarea__inner {
            padding: 10px 12px;
            height: 64px !important;
          }
        }
        .titleAll {
          .el-textarea__inner {
            padding: 10px 12px;
            height: 188px !important;
          }
        }
        .allTitle {
          .el-textarea__inner {
            padding: 10px 12px;
            height: 188px !important;
          }
        }
        .allTitle2 {
          .el-textarea__inner {
            padding: 10px 12px;
            height: 188px !important;
            @include useTheme {
              background: getVar('text-color1-f9f9f9');
              border: 1px solid getVar('color-e5e5e5-3b3b3b');
              color: getVar('text-color1-2c2c2c');
            }
          }
        }
        .addressInput {
          .el-input__inner {
            @include useTheme {
              background: getVar('bg-color-f6f6f6');
              border: 1px solid getVar('bg-color-f6f6f6');
              color: getVar('text-color1-d9d9d9');
            }
          }
        }
        .batchBox {
          width: 100%;
          height: 188px;
          background: #f6f6f6;
          border-radius: 8px;
          overflow-y: auto;
          padding: 10px 12px;
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          .batch {
            display: flex;
            align-items: center;
            .bfont1 {
              font-weight: 400;
              font-size: 12px;
              line-height: 20px;
              width: 194px;
              margin-right: 20px;
              @include multiline(1);
              @include useTheme {
                color: getVar('text-color1-2c2c2c');
              }
            }
          }
        }
      }
    }
  }
  .d-footer {
    margin: 20px 24px 0 0;
  }
}
</style>
<style lang="scss" scoped>
::v-deep .el-input {
  .el-input__inner {
    font-size: 12px !important;
    &::placeholder {
      font-size: 12px !important;
    }
  }
}
::v-deep.el-textarea {
  .el-textarea__inner {
    font-size: 12px !important;
    &::placeholder {
      font-size: 12px !important;
    }
  }
}
</style>
